<script setup>
import { inject } from 'vue';
const DLEvent = inject('DLEvent');
</script>
<template>
  <div class="tutorial-banner">
    <div class="tutorial-banner__inner">
      <div>
        <h2>руководство <br/>по уходу за&nbsp;щенком</h2>
        <p>В первые месяцы щенок активно растет и&nbsp;меняется. <br/>
          Календарь развития поможет не&nbsp;пропустить важные этапы взросления</p>
        <a
            href="https://www.proplan.ru/sites/default/files/2026-05/PuppyCareGuide.pdf"
            target="_blank"
            download=""
            @click="DLEvent('puppyPage_download_pdf')"
        >скачать pdf</a>
      </div>
      <img src="@/assets/img/tutorial-banner-image.png" alt=""/>
    </div>
  </div>
</template>